import { type ReactNode, useEffect } from 'react';
import { Icon, Slider } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useIsChannelEmpty } from 'features/channels/hooks/useIsChannelEmpty';
import type { ChannelsEventsListFilter } from '../../types';
import { EventCard } from '../event-card';
import { useEvents } from './hooks';

type P = {
  colSpan?: 10 | 7;
  controls: {
    hasTitleIcon?: boolean;
    seeAll?: { limit?: number; onClick?: () => void };
    title: ReactNode;
    titleLevel?: 2 | 4;
  };
  description?: ReactNode;
  emptyState?: ReactNode;
  getPathToEventDetail: (id: string) => string;
  onEmptyState?: (isEmpty: boolean) => void;
  query?: { filter?: ChannelsEventsListFilter };
};

// TODO: now this slider can be only used in places where we need channels events query with event slim response
const EventsSlider = ({
  colSpan,
  controls: { hasTitleIcon, seeAll, title, titleLevel },
  description,
  emptyState,
  getPathToEventDetail,
  onEmptyState,
  query,
}: P) => {
  const {
    isFeatured,
    query: { data, fetchNextPage, hasNextPage, isFetching, isLoading },
  } = useEvents({
    allowUnfeatured: Boolean(seeAll?.onClick),
    filter: query?.filter,
    pagination: { pageSize: 4 },
  });

  const events = data?.pages.flat();
  const fetchedEventLength = events?.length ?? 0;

  const isEmpty = useIsChannelEmpty(isLoading, events);

  // TODO this hack is needed together with useEffect in default channels to set empty state correctly
  useEffect(() => {
    onEmptyState?.(isEmpty);
  }, [isEmpty, onEmptyState]);

  return (
    <Slider
      colSpan={colSpan}
      controls={{
        seeAll: { limit: seeAll?.limit, onClick: seeAll?.onClick, total: fetchedEventLength },
        title,
        titleIcon: hasTitleIcon ? <Icon icon="mortarboard-line" /> : undefined, // TODO: event icon
        titleLevel,
      }}
      description={description}
      emptyState={emptyState}
      items={events?.map((event) => ({
        children: <EventCard event={event} getPathToEventDetail={getPathToEventDetail} />,
        key: `event-${event.id}`,
      }))}
      queryData={{
        fetchNextPage,
        hasNextPage: hasNextPage && isFeatured,
        isFetching,
        isLoading,
      }}
    />
  );
};

export default EventsSlider;
